import { ExperimentDetails } from './details';
import { ExperimentSummary } from './summary';

export const ExperimentOverviewTab = () => {
  return (
    <>
      <ExperimentSummary />
      <ExperimentDetails />
    </>
  );
};
